var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bindElement)?_c('div',{staticClass:"qr_img_wrap"},[_c('img',_vm._b({},'img',{ id: _vm.uuid },false))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }